export default __webpack_public_path__ + "static/media/logo_lock.6fc137d4.svg";